// Environment configuration
// This file helps manage environment variables across the application

// Auto-detect environment based on hostname
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const isProduction = window.location.hostname.includes('merzado.com') || window.location.hostname.includes('merzado.in') || window.location.hostname === 'www.merzado.com';

// Set URLs based on environment
const getBaseURL = () => {
  if (isDevelopment) {
    return process.env.REACT_APP_BASE_URL || 'http://localhost:8000/api';
  } else if (isProduction) {
    return process.env.REACT_APP_BASE_URL || 'https://api.merzado.com/api';
  }
  // Fallback to production for any other environment
  return 'https://api.merzado.com/api';
};

const getFrontendURL = () => {
  if (isDevelopment) {
    return process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000';
  } else if (isProduction) {
    return process.env.REACT_APP_FRONTEND_URL || 'https://www.merzado.com';
  }
  // Fallback to production for any other environment
  return 'https://www.merzado.com';
};

const config = {
  // Auto-detected values
  REACT_APP_BASE_URL: getBaseURL(),
  REACT_APP_FRONTEND_URL: getFrontendURL(),
  NODE_ENV: process.env.NODE_ENV || (isDevelopment ? 'development' : 'production'),
  IS_DEVELOPMENT: isDevelopment,
  IS_PRODUCTION: isProduction,

  // WebSocket configurations
  WEBSOCKET: {
    // Main application WebSocket (Socket.IO)
    MAIN: {
      // Remove /api and ensure clean URL for Socket.IO
      URL: (() => {
        const baseURL = getBaseURL();
        // Remove /api suffix if present
        const cleanURL = baseURL.replace(/\/api\/?$/, '');
        return cleanURL;
      })(),
      NAMESPACE: '/api'
    },
    // Live stream WebSocket (raw WebSocket)
    LIVESTREAM: {
      URL: isDevelopment ? 'ws://localhost:9099' : 'wss://api.merzado.com:9099'
    }
  }
};

// Log environment info for debugging
// console.log('Environment detected:', {
//   hostname: window.location.hostname,
//   isDevelopment,
//   isProduction,
//   baseURL: config.REACT_APP_BASE_URL,
//   websocketURL: config.WEBSOCKET.MAIN.URL
// });

export default config;

